import React from 'react';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import ReviewList from '../components/ReviewList';
import { ReviewAPI } from '../../../api';
import withAdminOnly from '../components/AdminOnly';

const statusOptions = [
  'pending',
  'active',
  'profane',
  'inactive'
];

const ReviewModerationPage = () => {
  const [status, setStatus] = React.useState('pending');
  const [data, setData] = React.useState(null);
  const [count, setCount] = React.useState(0);

  const getData = async () => {
    try {
      const { payload } = await ReviewAPI.adminReviewList(null, null, false, 100, 0, status);
      setData(payload);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  const setItemStatus = async (review_uuid, status) => {
    try {
      await ReviewAPI.adminUpdateReview(review_uuid, {'status': status});
      setCount(count + 1);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  React.useEffect(() => {
    getData();
  }, [status, count]);  // eslint-disable-line

  return (
    <Page title="Review Moderation">
      <SiteAdmin>
        <Typography variant="h6" color="primary">Review Moderation</Typography>
        <ReviewList
          data={data}
          status={status}
          statusOptions={statusOptions}
          setStatus={setStatus}
          setItemStatus={setItemStatus}
        />
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(ReviewModerationPage);
